export class PostContentCharCounterListener {
    public static bindTextareaInput(textarea: HTMLTextAreaElement, onInput: () => void): void {
        textarea.addEventListener("input", onInput);
    }
}
